var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "v-application",
      staticStyle: { width: "100%" },
      attrs: { "data-app": "" },
      on: {
        click: function($event) {
          $event.stopPropagation()
        }
      }
    },
    [
      _c("v-select", {
        key: _vm.countKey,
        ref: "select",
        attrs: {
          label: _vm.label,
          "item-value": "email",
          "item-text": "email",
          "hide-details": "",
          items: _vm.emails,
          "item-disabled": function(v) {
            return !v.validated
          }
        },
        on: { change: _vm.updateEmail },
        scopedSlots: _vm._u(
          [
            {
              key: "item",
              fn: function(ref) {
                var item = ref.item
                var on = ref.on
                return [
                  _c(
                    "div",
                    _vm._g(
                      {
                        staticClass: "d-flex align-items-center",
                        staticStyle: {
                          "justify-content": "space-between",
                          width: "100%"
                        },
                        attrs: { disabled: "" }
                      },
                      on
                    ),
                    [
                      _c("p", { staticClass: "mb-0" }, [
                        _vm._v(_vm._s(item.email))
                      ]),
                      _c("small", { staticClass: "text-secondary" }, [
                        _vm._v(
                          _vm._s(
                            item.validated ? "Válido" : "Aguardando validação"
                          )
                        )
                      ])
                    ]
                  )
                ]
              }
            },
            _vm.hasInvalid
              ? {
                  key: "append-item",
                  fn: function() {
                    return [
                      _c("v-divider"),
                      _c(
                        "div",
                        {
                          staticClass:
                            "pad v-list-item v-list-item--link theme--light",
                          on: { click: _vm.addNew }
                        },
                        [_vm._v(" Validar meu e-mail ")]
                      )
                    ]
                  },
                  proxy: true
                }
              : null
          ],
          null,
          true
        ),
        model: {
          value: _vm.email,
          callback: function($$v) {
            _vm.email = $$v
          },
          expression: "email"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }